import { Button } from "@mui/material";
import React from "react";
import { requestPermissionAndGenerateToken } from "firebaseApp";

export default function EnableNotificationsButton() {
  
  const handleEnableNotifications = async () => {
    const token = await requestPermissionAndGenerateToken();
    console.log(token);
  }

  return (
    <Button
      onClick={handleEnableNotifications}
    >
      Enable Notifications
    </Button>
  );

}
